<template>
  <b-container>
    <!-- HEADER -->
    <b-row>
      <b-col cols="12">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h3 class="font-weight-bold">Turnover Reports</h3>
            <small class="text-muted">
              Betting turnover analysis and trends
            </small>
          </div>

          <div class="d-flex align-items-center">
            <b-button variant="primary" class="text-nowrap" size="sm">
              <feather-icon icon="DownloadIcon" />
              Export
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="12">
        <b-row>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(59, 130, 246);
                background: linear-gradient(
                  rgb(239, 246, 255),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="text-muted"> Total Turnover (MTD) </span>
              <h3 class="font-weight-bolder">$13.8M</h3>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(16, 185, 129);
                background: linear-gradient(
                  rgb(236, 253, 245),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted"> Racing Turnover </span>
              <h3 class="font-weight-bolder">$7.6M</h3>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(239, 68, 68);
                background: linear-gradient(
                  rgb(254, 242, 242),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted">Sports Turnover</span>
              <h3 class="font-weight-bolder">$6.2M</h3>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(132, 204, 22);
                background: linear-gradient(
                  rgb(247, 254, 231),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted">Avg Daily </span>
              <h3 class="font-weight-bolder">$1.73M</h3>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { BContainer, BRow, BCol, BCard, BButton } from "bootstrap-vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BButton,
    FeatherIcon,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
.ngr-card {
  background: #ffffff;
}

.report-item {
  padding: 12px 0;
  border-bottom: 1px solid #f1f1f1;
}

.report-item:last-child {
  border-bottom: none;
}

.excel-icon-purple {
  width: 36px;
  height: 36px;
  background: #ede9fe;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ngr-total-row {
  background-color: #d1fae5 !important;
  font-weight: 600;
}
</style>